<template>
  <div>
    <div class="mask-container" v-if="disabled"></div>
    <div>
      <div class="inputBtn">
        <div>
          <el-input v-if="showSearch" v-model="filterText" placeholder="请输入关键字进行过滤" clearable 
            prefix-icon="el-icon-search" style="margin-bottom: 5px">
          </el-input>
        </div>
        <div>
          <el-button v-if="showRefresh"  circle style="margin-left: 5px" @click="onRefresh">
            <svg-icon  class-name="refresh" icon-class="refresh" />
          </el-button>
        </div>
      </div>
      <el-scrollbar :height="height" :native="true">
        <div style="display: flex;">
          <div >
            <el-tree v-loading="_loading" class="filter-tree" v-if="refreshTree" :data="treeOpts" :props="treeProps"
              :expand-on-click-node="false" :filter-node-method="filterNode" :default-expand-all="expandAll"
              :show-checkbox="showCheckbox" node-key="organId" ref="treeRef" highlight-current :draggable="draggable"
              :allow-drop="handleAllowDrop" @node-click="handleNodeClick" @node-expand="handleNodeExpand"
              @node-drop="handleNodeDrop">
              <template #default="{ node, data }">
                <span class="label">
                  <span>{{ node.label }}</span>
                </span>
              </template>
            </el-tree>
          </div>

        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance, onMounted, ref, watch } from "vue";
import {  moveNode } from "@/api/system/mechanism";
import { newGetSimpleTress } from "@/api/system/organ";
// import { useStore } from "vuex";
import { deepClone } from "@/utils/fangerUtils"
import { getChild} from "@/api/system/mechanism";
const props = defineProps({
  height: {
    required: false,
    type: String,
    default: 'calc(100vh - 250px)'
  },
  treeOptions: {
    required: false,
    type: Array,
    default: null
  },
  loading: {
    required: false,
    type: Boolean,
    default: false
  },
  getTreeOptions: {
    required: false,
    type: Function,
  },
  showSearch: {
    required: false,
    type: Boolean,
    default: false
  },
  showRefresh: {
    required: false,
    type: Boolean,
    default: false
  },
  draggable: {
    required: false,
    type: Boolean,
    default: false
  },
  showActionBut: {
    required: false,
    type: Boolean,
    default: false
  },
  addChildFun: {
    required: false
  },
  updateFun: {
    required: false
  },
  deleteFun: {
    required: false
  },
  isFefreshChildNode: {
    required: false,
    type: Boolean,
    default: false
  },
  refreshNodeData: {
    required: false,
    type: Object,
    default: () => null
  },
  curKey: {
    required: false,
    type: String,
    default: ''
  },
  closeExpand: {
    required: false,
    type: Boolean,
    default: false
  },
  // 是否可以取消当前选择，默认为false
  cancelCurSelect: {
    required: false,
    type: Boolean,
    default: false
  },
  disabled: {
    required: false,
    type: Boolean,
    default: false
  },
  // 是否可以多选
  showCheckbox: {
    required: false,
    type: Boolean,
    default: false
  }
})

// const store = useStore()
const { proxy } = getCurrentInstance()
// 树结构参数
const refreshTree = ref(true)
const treeRef = ref(null)
const _loading = ref(false)
const filterText = ref('')
const treeOpts = ref([])
const curParentNode = ref(null)
const treeProps = {
  label: 'organName',
  children: 'child'
}


const expandAll = ref(false)
onMounted(() => {
  // 监听过滤词
  watch(() => filterText.value,
    (newVal, oldVal) => {
      proxy.$refs.treeRef.filter(newVal)
    }
  )

  // 监听是否刷新子节点
  watch(() => props.isFefreshChildNode,
    (newVal, oldVal) => {
      if (newVal) {
        if (props.refreshNodeData !== null) {
          findChildNode(props.refreshNodeData)
        } else {
          emits('onRefreshChildNodeSuccess')
        }

      }
    }, {
    immediate: true
  }
  )

  // 监听节点树的变化
  watch(() => props.treeOptions,
    (newVal, oldVal) => {
      treeOpts.value = deepClone(newVal)
    }, {
    immediate: true
  }
  )

  // 监听是否正在加载
  watch(() => props.loading,
    (newVal, oldVal) => {
      _loading.value = newVal
    }, {
    immediate: true
  }
  )

  // 监听设置当前显示的 节点 key
  watch(() => props.curKey,
    (newVal, oldVal) => {
      if (newVal) {
        proxy.$nextTick(() => {
          proxy.$refs["treeRef"].setCurrentKey(newVal)
        })
      }
    }, {
    immediate: true
  }
  )
  // 监听是否关闭展开的节点
  watch(() => props.closeExpand,
    (newVal) => {
      expandAll.value = false
      refreshTree.value = false
      proxy.$nextTick(() => {
        refreshTree.value = true
      })
    }
  )
  emits('getTreeRef', treeRef.value)
})

const emits = defineEmits([
  "onNodeClick",
  "onRefreshTree",
  'onChildNodeData',
  'cancelCurSelect',
  'getTreeOpts',
  'onRefreshChildNodeSuccess',
  'getTreeRef'
])

// 获取节点树
const getTreeOptions = async () => {
  _loading.value = true
  treeOpts.value =  await newGetSimpleTress().then(resData => { //新接口树
    _loading.value = false
    const expandData = filterExpandData(resData.data)
    return expandData
  })
  
  let clickTreeData = {}
  if (treeOpts.value.length > 0) {
    clickTreeData = {
      [treeOpts.value[0].nodeType]: treeOpts.value.map(item => item.organId).join(','),
    }
  }
  emits('onNodeClick', clickTreeData)

}
const filterExpandData=(data)=>{
  data?.forEach(item=>{
    if(item.hasChild == '1'){
      let child = [{
          organId: "xnzjd0001" + item.organId,
          organName: "正在加载",
          child: []
      }]
      item.child=child
    }
  })
  return data
}
const getTreeOpts = async () => {
  if (props.treeOptions === null) {
    if (props.getTreeOptions === undefined) {
      getTreeOptions()
    } else {
      treeOpts.value = await props.getTreeOptions()
    }
  } else {
    treeOpts.value = deepClone(props.treeOptions)
  }
}

getTreeOpts()


const filterNode = (value, data) => {
  if (!value) return true
  return data.organName.indexOf(value) !== -1
}


let curNodeItem = null
const handleNodeClick = (data, nodeItem, event) => {
  if (curNodeItem && props.cancelCurSelect && curNodeItem === nodeItem) {
    curNodeItem = null
    treeRef.value.setCurrentKey(null)
    let clickTreeData = {}
    if (treeOpts.value.length > 0) {
      clickTreeData = {
        organId: treeOpts.value.map(item => item.organId).join(','),
        nodeType: treeOpts.value[0].nodeType
      }
    }
    emits('cancelCurSelect', clickTreeData)


  } else {
    curNodeItem = nodeItem
    emits('onNodeClick', data, nodeItem)
  }
}

// 展开节点
//共三个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、节点对应的 Node、节点组件本身
const handleNodeExpand = async (data, node, item) => {
  // 判断是否需要加载子节点数据
  if (node.childNodes && node.childNodes.length > 0 && node.childNodes[0].data.organName === '正在加载') {
    findChildNode(data)
  }
}

// 判断节点是否可以移动
const handleAllowDrop = (draggingNode, dropNode, type) => {
  if (type === "prev" || type === "next") {
    return draggingNode.parent.data.nodeType === dropNode.parent.data.nodeType
  } else {
    return draggingNode.parent.data.nodeType === dropNode.data.nodeType
  }

}

// 移动节点
const handleNodeDrop = (drodraggingNode, dropNode, dropType, ev) => {
  const fromData = drodraggingNode.store.nodesMap[drodraggingNode.data.parentId].data
  let toData = dropNode.data
  const dropData = drodraggingNode.data
  if (dropType === "before" || dropType === "after") {
    toData = dropNode.parent.data
  }
  const moveData = {
    fromId: fromData.organId,
    toId: toData.organId,
    id: dropData.organId
  }
  moveNode(moveData).then(resData => {
    handleNodeClick(curParentNode.value)  // 更新表格数据
  })
}

// 查询当前节点的子节点
const findChildNode = async (data) => {
  _loading.value = true
  getChild({
      parentId: data.organId
    }).then(resData => {
      proxy.$nextTick(() => {
        const expandData = filterExpandData(resData.data)
        proxy.$refs["treeRef"].updateKeyChildren(data.organId, expandData)
        data.child = expandData
        emits('onChildNodeData', resData.data)
        emits('getTreeOpts', treeOpts.value)
        emits('onRefreshChildNodeSuccess')
      })
    }).finally(()=>{
      _loading.value = false
    })
}

// 刷新
const onRefresh = () => {
  if (props.treeOptions === null) {
    getTreeOpts()
  } else {
    emits('onRefreshTree')
  }

}
</script>

<style lang="scss" scoped>
.mask-container {
  position: absolute;
  background-color: #5a5e66;
  top: -10px;
  left: -10px;
  opacity: 0.2;
  width: 102%;
  height: 101%;
  z-index: 999;
}

.inputBtn{
  display: flex;
  justify-content: flex-start;
}
.disabled {
  cursor: not-allowed;
  position: absolute;
  top: -5px;
  left: -120px;
  right: 50px;
  bottom: -5px;
  z-index: 2;
}
:deep(.el-tree-node__content)   .label{
      position: relative;
      width: 100%;
    }
  :deep(.el-scrollbar__view)>div{
    display: block !important
  }
</style>